import React from "react";
import { Box, Container, Paper } from "@mui/material";
import Logo from "../../components/Logo";
import happy from "assets/happy.svg";

const Success = ({ content, isNEO = false, navigateUrl = "", lang = "" }) => {
  const handleCheckResult = () => {
    window.location.href = navigateUrl;
  };
  return (
    <Box
      sx={{
        background: "#f7f7f7",
        minHeight: "100vh",
        "@supports (min-height: 100dvh)": {
          minHeight: "100dvh",
        },
        overflow: "auto",
      }}
    >
      <Container className="pt-8">
        <Paper elevation={1} className="bg-white py-6 px-[3%] !rounded-lg ">
          <Logo />
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-150px)]">
            <img src={happy} className="max-w-[300px] px-4" alt="" />
            <div className="text-[22px] font-bold mt-8">
              {lang === "en" ? "Survey completed successfully" : "Khảo sát thành công"}
            </div>
            <div className="max-w-[900px] text-center">{content}</div>
            {isNEO && (
              <div className="w-full mt-20 flex justify-center">
                <button
                  className="w-full lg:max-w-[300px] py-3 flex items-center justify-center rounded-xl bg-[#01AD53] text-white text-[16px] font-medium leading-tight"
                  onClick={handleCheckResult}
                >
                  {lang === "en" ? "View results" : "Xem kết quả"}
                </button>
              </div>
            )}
          </div>
        </Paper>
      </Container>
    </Box>
  );
};

export default Success;
